import HeroSection from './components/HeroSection';
import TrustBar from './components/TrustBar';
import AwardsSection from './components/AwardsSection';
import ServicesOverview from './components/ServicesOverview';
import MidCTA from './components/MidCTA';
import AIAnswerBlock from './components/AIAnswerBlock';
import ProcessSection from './components/ProcessSection';
import WhyChooseUs from './components/WhyChooseUs';
import ServiceAreas from './components/ServiceAreas';
import Testimonials from './components/Testimonials';
import FAQSection from './components/FAQSection';
import FinalCTA from './components/FinalCTA';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';

export default function HomePage() {
  return (
    <main className="font-sans bg-white min-w-[1024px]">
      <Navbar />
      <HeroSection />
      <TrustBar />
      <AwardsSection />
      <ServicesOverview />
      <MidCTA />
      <AIAnswerBlock />
      <ProcessSection />
      <WhyChooseUs />
      <ServiceAreas />
      <Testimonials />
      <FAQSection />
      <FinalCTA />
      <Footer />
    </main>
  );
}
